import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import fetchfromAPI from '../utils/fetchfromAPI'
import ChannelCard from './Feed/ChannelCard'
import Video from './Feed/Video'

const ChannelDetail = () => {
  const [channelDetail,setChannelDetail]=useState(null)
  const [videos,setVideo]=useState([])
  const {id}= useParams()
  
  useEffect(()=>{
    fetchfromAPI(`channels?part=snippet&id=${id}`).then((data)=>setChannelDetail(data?.items[0]))
    fetchfromAPI(`search?channelId=${id}&part=snippet&order=date`).then((data)=>setVideo(data?.items))
  },[id])
  // console.log(channelDetail,videos);
  return (
    <div>
      <Box className="h-[95vh]">
        <Box>
          <div style={{ background:"linear-gradient(90deg, rgba(36,0,6,1) 0%, rgba(161,42,92,1) 72%)",}} className="h-[40vh]"/>
          <center><ChannelCard channelDetail={channelDetail}  marginTop="-93px" /></center>
        </Box>
    
        <Box className="bg-black flex">
              <Video videos={videos}/>
        </Box>
      </Box>
    </div>
  )
}

export default ChannelDetail
